



















































































































import Vue from 'vue'
import Person from '@/types/Person.interface'
import PersonsAutocomplete from '@/components/PersonsAutoComplete.vue'
export default Vue.extend({
    components: { PersonsAutocomplete },
    props: {
        invoice: {
            type: Object,
            required: true
        },
        new: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            datePicker: false,
            person: null,
            loading: false,
            model: null
        }
    },
    mounted() {
        //  Create a temp copy of the invoice to perform updates on
        this.model = window._.cloneDeep(this.invoice)

        //  If the invoice has a person attached, fetch that person to display on form
        if (this.model.person_id) this.setPerson(this.model.person_id)
    },
    computed: {
        dueDateFormatted(): string {
            // If no date, return null
            if (!this.model.due_date) return null

            //  Pull year, month, day from ISO String date
            const [year, month, day] = this.model.due_date.substring(0, 10).split('-')

            //  Return date formatted in mm/dd/yyyy
            return `${month}/${day}/${year}`
        },
        subtotal(): string {
            //  Init subtotal
            let subtotal = 0

            //  Add up price * quantity for each line item
            this.model.lines.forEach((line) => {
                subtotal += parseFloat(line.Price) * line.Quantity
            })

            //  Return subtotal (tax not included) to two decimal points
            return subtotal.toFixed(2)
        },
        taxTotal(): string {
            //  Init tax
            let tax = 0

            //  Add up tax for each line item
            this.model.lines.forEach((line) => {
                tax += parseFloat(line.Price) * (line.Tax / 100) * line.Quantity
            })

            //Return total tax
            //  If tax is type number
            if (typeof tax == 'number') return tax.toFixed(2)
            // Else change string to float
            return parseFloat(tax).toFixed(2)
        },
        total(): string {
            //  Return subtotal calculation + tax calculation
            return (parseFloat(this.subtotal) + parseFloat(this.taxTotal)).toFixed(2)
        }
    },
    methods: {
        addLineItem(): object {
            //  Push default line item onto the temp invoice
            return this.model.lines.push({
                Description: null,
                Quantity: 1,
                Price: parseFloat('0').toFixed(2),
                Tax: parseFloat('0').toFixed(2)
            })
        },
        assignPerson(person: Person): void {
            // Set the person on the form (received from search bar)
            this.person = person
        },
        removeLineItem(index: number): void {
            //  Remove a single line item
            this.model.lines.splice(index, 1)
        },
        async setPerson(person_id: number): Promise<void> {
            //  When component is mounted, fetch person and set them on the form
            this.person = await this.$store.dispatch('personsFind', person_id)
        },
        async submit(openNew: boolean = false): Promise<void> {
            //  Await form input validation
            const valid = await this.$validator.validateAll()

            //  If form is valid, return
            if (!valid) return

            //  Next, make sure we have a person for the invoice
            if (!this.person) {
                return this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    icon: 'mdi-alert',
                    title: 'Invoice Error',
                    text: 'Please assign a contact to this invoice.',
                    color: 'primary'
                })
            }

            //  Set the person_id on the invoice
            this.model.person_id = this.person.id

            //  Set the final total
            this.model.total = this.total

            //  Init response
            let response = null

            //  Start the loading spinner
            this.loading = true

            if (this.new) {
                //  If new invoice, the balance will be the same as its total
                this.model.balance = this.total

                //  Create the invoice
                response = await this.$store.dispatch('invoicesPost', this.model)
            } else {
                //  If not a new invoice, we add the new total subtracted from the previous total to the balance
                this.model.balance =
                    parseFloat(this.model.balance) +
                    (this.total - parseFloat(this.invoice.total))

                //  Update the invoice
                response = await this.$store.dispatch('invoicesPut', this.model)
            }

            //  Stop the loading spinner
            this.loading = false

            //  If create/update was successful, return callback
            if (response) this.$emit('submit', { invoice: response, openNew: openNew })
        }
    }
})
